import { HTTP } from '../../../http-common';
import { NBNHardware } from '../../../models/NbnHardware';
import { createHelpers } from 'vuex-map-fields';

import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '../../../models/httpError';

const state = {
  nbnHardware: new NBNHardware(),
  nbnHardwares: [],
  message: new httpError(),
};

const getters = {
  nbnHardware: state => {
    state.nbnHardware;
  },
  nbnHardwares: state => {
    return state.nbnHardwares;
  },
  getField,
};

//Mutations
const mutations = {
  setHardwareOrder(state, nbnHardware) {
    if (nbnHardware === '') state.nbnHardware = new NBNHardware();
    else state.nbnHardware = order;
  },
  setNbnHardwares(state, nbnHardwares) {
    state.nbnHardwares = nbnHardwares;
  },
  clearRows(state) {
    state.rows = [];
  },
  setProgress(state, message) {
    state.message = message;
  },
  deleteNbnHardware(state, hardwareID) {
    let index = state.nbnHardwares.findIndex(x => x.hardwareID == hardwareID);
    if (index > -1) {
      state.nbnHardwares.splice(index, 1);
    }
  },
  updateNbnHardwares(state, hardware) {
    if (Array.isArray(state.nbnHardwares)) {
      // It's an array, you can use forEach on it.
      state.nbnHardwares.forEach(function(e) {
        if (e.id == hardware.id) {
          e = hardware;
        }
      });
    }
    // state.nbnHardwares.foreach(e => {
    //   if (e.id == hardware.id) {
    //     e = hardware;
    //   }
    // });
  },
  addNbnHardware(state, hardware) {
    state.nbnHardwares.push(hardware);
  },
  updateField,
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit('setHardwareOrder', new NBNHardware());
    commit('clearRows');
    commit('setProgress', new httpError());
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
  getNBNHardwares({ commit, dispatch }, archive) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(`NBNHardware/GetNBNHardwares/${archive}`);
      response
        .then(function(data) {
          if (data.status === 200) {
            let resultData = data.data;
            commit('setNbnHardwares', resultData);
            resolve(resultData);
          }
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error:' + err, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
  upsertNBNHardware({ commit, dispatch }, hardware) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(`NBNHardware/UpsertNBNHardware`, hardware);
      response
        .then(function(data) {
          if (data.status === 200) {
            let resultData = data.data;
            if (resultData.archive) {
              commit('deleteNbnHardware', resultData.id);
            } else {
              commit('updateNbnHardwares', resultData);
            }
            resolve(resultData);
          }
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error:' + err, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
  deleteNbnHardware({ commit, state }, id) {
    commit('deleteNbnHardware', id);

    return state.nbnHardwares;
  },
};

export const { mapFields: mapNbnHardwareFields } = createHelpers({
  getterType: `nbnHardware/getField`,
  mutationType: `nbnHardware/updateField`,
});
export const {
  mapMultiRowFields: mapNbnHardwareMultiRowFields,
} = createHelpers({
  getterType: 'nbnHardware/getField',
  mutationType: 'nbnHardware/updateField',
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
